import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Initialize with 23h 59m 59s
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 md:space-x-4 text-white font-bold text-3xl md:text-5xl tracking-wider" data-id="element-249">
      <div className="flex flex-col items-center bg-oscuro/50 px-4 py-3 rounded-lg backdrop-blur-sm min-w-[80px] md:min-w-[100px]" data-id="element-250">
        <span data-id="element-251">{format(timeLeft.hours)}</span>
        <span className="text-xs md:text-sm font-normal text-gray-300 mt-1" data-id="element-252">
          HS
        </span>
      </div>
      <span className="text-oscuro/50 pb-6" data-id="element-253">:</span>
      <div className="flex flex-col items-center bg-oscuro/50 px-4 py-3 rounded-lg backdrop-blur-sm min-w-[80px] md:min-w-[100px]" data-id="element-254">
        <span data-id="element-255">{format(timeLeft.minutes)}</span>
        <span className="text-xs md:text-sm font-normal text-gray-300 mt-1" data-id="element-256">
          MIN
        </span>
      </div>
      <span className="text-oscuro/50 pb-6" data-id="element-257">:</span>
      <div className="flex flex-col items-center bg-oscuro/50 px-4 py-3 rounded-lg backdrop-blur-sm min-w-[80px] md:min-w-[100px]" data-id="element-258">
        <span data-id="element-259">{format(timeLeft.seconds)}</span>
        <span className="text-xs md:text-sm font-normal text-gray-300 mt-1" data-id="element-260">
          SEG
        </span>
      </div>
    </div>;
}